<script setup>
import { reactiveOmit } from '@vueuse/core';
import { DatePickerCalendar, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps({
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
    class: { type: null, required: false },
});

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <DatePickerCalendar v-slot="slotProps" :class="cn('p-3', props.class)" v-bind="forwardedProps">
        <slot v-bind="slotProps" />
    </DatePickerCalendar>
</template>
